'use client'

import React, { createContext, useContext } from 'react'
import { CustomerData } from 'types/AsaasApi'

import AbTestType from 'types/AbTestType'
import { PartialReleaseType } from 'types/PartialReleaseType'

export type PageContextType = {
  customerData: CustomerData
  customerOriginChannel: string
  pageName?: string
  abTests?: AbTestType[]
  partialReleases?: PartialReleaseType[]
}

const defaultContext = {
  pageName: undefined,
  abTests: undefined,
  partialReleases: undefined,
  customerData: {
    isCustomer: false,
    isLegalPerson: false
  },
  customerOriginChannel: ''
}

export const PageContext = createContext<PageContextType>(defaultContext)

export const usePageContext = () => {
  return useContext(PageContext)
}

interface PageProviderProps {
  pageData: PageContextType
  children: React.ReactNode
}

const PageContextProvider = ({ pageData, children }: PageProviderProps) => {
  return <PageContext.Provider value={pageData}>{children}</PageContext.Provider>
}

export { PageContextProvider }
